export const saveNewUSQS = async (
  axiosPrivate,
  QSData,
  ppaymenttermData,
  setReloadlistdata,
  reloadlistdata,
  setSPM,
  setShowSPM,
  showSPM,
  spaymenttermData,
  clearUSQS,
  setReloadPoslistdata
) => {
  try {
    const response = await axiosPrivate.post("/api/qs/addnewUSQS", { QSData });
    if (response.data.message === "Saved") {
      setReloadlistdata(!reloadlistdata);
      setReloadPoslistdata((prev) => !prev);
      const response1 = await axiosPrivate.post("/api/qs/addQSppayterms", {
        payterms: ppaymenttermData,
        USQSID: response.data.resultID,
        origin: "purchase",
      });
      if (response1.data.message === "Saved") {
        const response2 = await axiosPrivate.post("/api/qs/addQSspayterms", {
          payterms: spaymenttermData,
          USQSID: response.data.resultID,
          origin: "sales",
        });
        if (response2.data.message === "Saved") {
          setSPM(response.data.message);
          setShowSPM(!showSPM);
          clearUSQS();
        }
      }
    }
  } catch (err) {
    console.error(err);
  }
};

// Reduce edits preparing for Save Edits
function reduceEdits(arr) {
  const map = new Map();
  for (const obj of arr) {
    const existing = map.get(obj.name);
    if (!existing || obj.editID > existing.editID) {
      map.set(obj.name, obj);
    }
  }
  return Array.from(map.values());
}
/// Save Edits for existing QS
export const saveEdits = async (
  currentEdits,
  axiosPrivate,
  qstoedit,
  setReloadlistdata,
  setSPM,
  setShowSPM,
  ppaymenttermData,
  spaymenttermData,
  setReloadPoslistdata
) => {
  // console.log(ppaymenttermData);
  // console.log(spaymenttermData);
  const edits = reduceEdits(currentEdits.current);
  let editvalues = edits.map((item) => (item.nameID ? { [item.nameID]: item.valueID } : { [item.name]: item.num }));
  // filter out supplierID, payType, portion, termdays
  const filtered = editvalues.filter((obj) => {
    const key = Object.keys(obj)[0]; // each object only has one key
    return (
      key !== "supplierID" &&
      !key.includes("payType") &&
      !key.includes("portion") &&
      !key.includes("termdays") &&
      !key.includes("addrow") &&
      !key.includes("delrow") &&
      !key.includes("posloadedtoqs") &&
      !key.includes("ptermsfrompos")
    );
  });
  console.log(filtered);
  try {
    const response = await axiosPrivate.post("/api/qs/updateUSQS", {
      data: filtered,
      qstoedit: qstoedit,
      ppaymenttermData: ppaymenttermData,
      spaymenttermData: spaymenttermData,
    });
    if (response.data.message === "Edits Saved") {
      setReloadlistdata((prev) => !prev);
      setReloadPoslistdata((prev) => !prev);
      setSPM(response.data.message);
      setShowSPM((prev) => !prev);
    }
  } catch (err) {
    console.error(err);
  }
};

// Save new Spain QS
export const saveNewSPQS = async (
  axiosPrivate,
  QSData,
  ppaymenttermData,
  setReloadlistdata,
  reloadlistdata,
  setSPM,
  setShowSPM,
  showSPM,
  spaymenttermData,
  clearQS,
  setReloadPoslistdata
) => {
  try {
    const response = await axiosPrivate.post("/api/qs/addnewSPQS", { QSData });
    if (response.data.message === "Saved") {
      setReloadlistdata(!reloadlistdata);
      setReloadPoslistdata((prev) => !prev);
      const response1 = await axiosPrivate.post("/api/qs/addSPQSppayterms", {
        payterms: ppaymenttermData,
        SPQSID: response.data.resultID,
        origin: "purchase",
      });
      if (response1.data.message === "Saved") {
        const response2 = await axiosPrivate.post("/api/qs/addSPQSspayterms", {
          payterms: spaymenttermData,
          SPQSID: response.data.resultID,
          origin: "sales",
        });
        if (response2.data.message === "Saved") {
          setSPM(response.data.message);
          setShowSPM(!showSPM);
          clearQS();
        }
      }
    }
  } catch (err) {
    console.error(err);
  }
};

/// Save Edits for existing Spain QS
export const saveEditsSP = async (
  currentEdits,
  axiosPrivate,
  qstoedit,
  setReloadlistdata,
  setSPM,
  setShowSPM,
  ppaymenttermData,
  spaymenttermData,
  setReloadPoslistdata
) => {
  // console.log(ppaymenttermData);
  // console.log(spaymenttermData);
  const edits = reduceEdits(currentEdits.current);
  let editvalues = edits.map((item) => (item.nameID ? { [item.nameID]: item.valueID } : { [item.name]: item.num }));
  // filter out supplierID, payType, portion, termdays
  const filtered = editvalues.filter((obj) => {
    const key = Object.keys(obj)[0]; // each object only has one key
    return (
      key !== "supplierID" &&
      !key.includes("payType") &&
      !key.includes("portion") &&
      !key.includes("termdays") &&
      !key.includes("addrow") &&
      !key.includes("delrow") &&
      !key.includes("posloadedtoqs") &&
      !key.includes("ptermsfrompos")
    );
  });
  console.log(filtered);
  try {
    const response = await axiosPrivate.post("/api/qs/updateSPQS", {
      data: filtered,
      qstoedit: qstoedit,
      ppaymenttermData: ppaymenttermData,
      spaymenttermData: spaymenttermData,
    });
    if (response.data.message === "Edits Saved") {
      setReloadlistdata((prev) => !prev);
      setReloadPoslistdata((prev) => !prev);
      setSPM(response.data.message);
      setShowSPM((prev) => !prev);
    }
  } catch (err) {
    console.error(err);
  }
};
